import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import Actions from '../redux/actions/index';
import ReactStars from "react-rating-stars-component";
import Constants from '../utils/Constants';
import AppLoader from '../utils/AppLoader';
import stringTamil from '../utils/stringTamil';
import stringEnglish from '../utils/stringEnglish';
import { isUserName } from '../utils/validation';
import { toast } from 'react-toastify';
import PatientCallSession from '../utils/patientCallSession';

class KioskFeedback extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            feedBack: '',
            customerRating: 0,
            encryptId: '',
            language: parseInt(localStorage.getItem("language")) || 1,
            error: {},
            message: {},
            fullname: "",
            feedbackRoomId: null,
        };
    }
    componentDidMount() {
        let encryptId = localStorage.getItem("vendorId");
        const feedbackRoomId = PatientCallSession.getFeedbackRoomId()
            || this.props.getCustomerToken
            || null;
        this.setState({ encryptId: encryptId, feedbackRoomId });
        if (PatientCallSession.consumeSessionEndedMessage()) {
            toast.info(Constants.SESSION_ENDED || 'Session is ended');
        }
        try {
            window.history.replaceState(null, '', window.location.href);
        } catch (e) {
            /* ignore */
        }
    }

    getFeedbackRoomId = () => {
        return this.state.feedbackRoomId
            || this.props.getCustomerToken
            || PatientCallSession.getFeedbackRoomId()
            || null;
    };

    goToMain = () => {
        PatientCallSession.clearFeedbackRoomId();
        this.props.history.replace(`/kiosk_srm/${this.state.encryptId}`);
    };

    submitHandler = () => {
        const { feedBack, customerRating, fullname } = this.state;
        const customerRoomId = this.getFeedbackRoomId();
        let params = {
            roomId: customerRoomId,
            ratings: customerRating,
            feedback: feedBack,
            fullName: fullname
        };
        let MESSAGE = this.state?.language === 2 ? stringTamil?.MESSAGE : stringEnglish?.MESSAGE;
        if (!params.fullName) {
            this.setState({ error: { isFullName: true }, message: { isFullName: MESSAGE?.PLEASE_ENTER_THE_NAME } });
        } else if (params.fullName.trim().length < 3) {
            this.setState({ error: { isFullName: true }, message: { isFullName: MESSAGE?.FULL_NAME_MINIMUM_CHARACTER } });
        } else if (!isUserName(params.fullName)) {
            this.setState({ error: { isFullName: true }, message: { isFullName: MESSAGE?.NAME_REGX } });
        } else if (!customerRoomId) {
            toast.info(MESSAGE?.SESSION_ENDED || Constants.SESSION_ENDED || 'Session is ended');
            this.goToMain();
        } else {
            this.props.feedBack(params, () => {
                this.goToMain();
            });
        }
    };
    ratingChanged = (newRating) => {
        this.setState({ customerRating: newRating });
    };
    handleChange = (e) => {
        let fullname = e.target.value;
        let MESSAGE = this.state?.language === 2 ? stringTamil?.MESSAGE : stringEnglish?.MESSAGE;
        if (!fullname || fullname.length === 0) {
            this.setState({ error: { isFullName: true }, fullname: e.target.value, message: { isFullName: MESSAGE?.PLEASE_ENTER_THE_NAME } });
            return false;
        }
        else if (fullname.trim().length < 3) {
            this.setState({ error: { isFullName: true }, fullname: e.target.value, message: { isFullName: MESSAGE?.FULL_NAME_MINIMUM_CHARACTER } });
        }
        else if (!isUserName(fullname)) {
            this.setState({ error: { isFullName: true }, fullname: e.target.value, message: { isFullName: MESSAGE?.NAME_REGX } });
        }
        else {
            this.setState({ error: { isFullName: false }, fullname: e.target.value, message: { isFullName: '' } });
        }
    };
    render() {
        const { isLoading } = this.props.feedBackLoader;
        const { language, error, message } = this.state;
        let MESSAGE = language === 2 ? stringTamil?.MESSAGE : stringEnglish?.MESSAGE;
        return (
            <div className='d-flex flex-column overflow-auto gap-5 feedback-form nurse-kiosk-feedback'>
                {isLoading && <AppLoader />}
                <img className="logo" src={require('../assets/img/srm-logo.png')} alt="logo" />
                <div className='feed-form-inputs w-auto' style={{ width: 'min(480px, 92vw)' }}>
                    <h1 className='feed-head'>{MESSAGE?.CALL_FEEDBACK?.FEEDBACK}</h1>
                    <p className='feed-para'>
                        {MESSAGE?.CALL_FEEDBACK?.FEEDBACK_HEADERS}
                    </p>
                    <h4 className='rate-text mb-0'>{MESSAGE?.CALL_FEEDBACK?.RATE_YOUR_EXPERIENCE}</h4>
                    <div className='rating-stars'>
                        <ReactStars
                            count={5}
                            onChange={this.ratingChanged}
                            size={44}
                            isHalf={true}
                            emptyIcon={<i className="far fa-star"></i>}
                            halfIcon={<i className="fa fa-star-half-alt"></i>}
                            fullIcon={<i className="fa fa-star"></i>}
                            activeColor="#6B4A98"
                        />
                    </div>
                    <div className="d-flex flex-column mt-3">
                        <label htmlFor="exampleFormControlInput1" className="commentsHeader">{MESSAGE?.FULLNAME} <span style={{ color: "red" }}>*</span></label>
                        <input autoComplete="off" type="text" className="form-control textarea-width w-100" id="exampleFormControlInput1"
                            placeholder={MESSAGE?.ENTER_NAME} style={{ height: '46px', minHeight: '46px' }} maxLength="30" onChange={(e) => this.handleChange(e)} />
                        <div>
                            {error.isFullName && <h5 style={{ color: 'red', fontSize: '16px', marginTop: '10px' }}>{message?.isFullName}</h5>}
                        </div>
                    </div>
                    <div className='d-grid gap-2 mt-4'>
                        <label className='commentsHeader'>{MESSAGE?.CALL_FEEDBACK?.COMMMENT_OPTIONAL} {MESSAGE?.CALL_FEEDBACK?.OPTIONAL}</label>
                        <textarea className='form-control textarea-width' placeholder={MESSAGE?.CALL_FEEDBACK?.YOUR_COMMENTS} onChange={(e) => this.setState({ feedBack: e.target.value })}></textarea>
                    </div>
                    <button className='btn send-btn btn-lg mt-4 w-100' type='button' onClick={() => this.submitHandler()}>{MESSAGE?.CALL_FEEDBACK?.SEND_FEEDBACK}</button>
                    <div className="skipDiv text-center mt-4 float-none">
                        <button type="button" className="skip btn btn-link p-0 border-0 text-center" onClick={this.goToMain}>
                            {MESSAGE?.CALL_FEEDBACK?.SKIP}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
export const mapStateToProps = (state) => {
    return {
        getCustomerToken: state?.CUSTOMER_LIST?.customerList?.response?.roomId,
        feedBackLoader: state?.FEEDBACK,
        getcutomerList: Actions.getcutomerList(state)
    };
};
export default withRouter(connect(mapStateToProps, {
    feedBack: Actions.feedBackAction
})(KioskFeedback));
